import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Paragraph } from '@scentregroup/ui'
import classNames from 'classnames'
import UtilityBox from '../utility-box'
import { slugify } from '../../helpers'
import { isTrustedUrl } from '../../helpers/url'
import { DISCOVER } from '../../constants'
import style from './index.scss'
const FEATURED_LINK = 'FeaturedLink'

const categoryLimit = 5
const entriesToLimit = entries => (entries || []).slice(0, categoryLimit)
const getTheUrlByTypeName = (centre, link) => {
  if (link.__typename === FEATURED_LINK) {
    try {
      return isTrustedUrl(link.url)
    } catch (e) {
      return ''
    }
  } else {
    return `/${centre.slug}/browse-stores/${slugify(link.title)}`
  }
}
const getUtilityPanelHeading = (centre, heading) =>
  (heading && heading.length) > 0 ? heading : `${DISCOVER} ${centre.title}`
const CentreUtilityBox = ({
  heading,
  entries,
  centre,
  angleOrigin,
  color,
  origin,
}) => {
  const bottomAngle =
    angleOrigin === 'top-left' ? 'bottom-right' : 'bottom-left'
  const utilityBoxComponent = (
    <div>
      <div
        className={classNames(
          style.angleAtTop,
          style[color],
          style[angleOrigin],
          style[origin]
        )}
      />

      <div className={classNames(style.wrapper, style[color], style[origin])}>
        <UtilityBox
          className={classNames(style.CentreUtilityBox, style[bottomAngle])}
        >
          <Link
            className={style.utilityDiscover}
            to={`/${centre.slug}/browse-stores`}
            data-test-id="discover-center"
          >
            {getUtilityPanelHeading(centre, heading)}
          </Link>
          <section className={style.links}>
            {entriesToLimit(entries).map(link => (
              <a
                className={style.utilityLink}
                href={getTheUrlByTypeName(centre, link)}
                key={link.title}
              >
                <Paragraph className={style.utilityLinkText}>
                  {link.title}
                </Paragraph>
              </a>
            ))}
          </section>
        </UtilityBox>
      </div>
    </div>
  )

  return entries && entries.length > 0 ? utilityBoxComponent : null
}

CentreUtilityBox.propTypes = {
  entries: PropTypes.array,
  heading: PropTypes.string,
  centre: PropTypes.object,
  angleOrigin: PropTypes.string,
  color: PropTypes.string,
  origin: PropTypes.oneOf(['modules', 'feature']),
}

export default CentreUtilityBox
